__webpack_require__.p = "https://qa-artemis.ritual.co//_next/";